import execute_on from "../../libs/execute-on";
import {attachDataTables} from "../../plugins/datatables";
import makeId from "../../libs/make-id";
import attachAdvancedSettings from "../../components/survey/attach-advanced-settings";

function redirectsPageHandler() {
    // elements
    const $checkData = $('#check-data');
    const $checkExperiment = $('#check-experiment');
    const $genderToggle = $(document.getElementById('gender.select_by_variable'));
    const $genderVariableName = $(document.getElementById('gender.variable_name'));
    const $genderFemaleValue = $(document.getElementById('gender.value_for_female'));
    const $genderMaleValue = $(document.getElementById('gender.value_for_male'));
    const $captureAllVariablesToggle = $(document.getElementById('capture_all_variables'));
    const $variablesToPass = $(document.getElementById('variables_to_pass'));

    // callbacks
    function showAnkieterData() {
        const $modal = $('#check-data-modal');

        $modal
            .modal('show')
            .find('.modal-content')
            .load($checkData.data('url'), function (responseText, textStatus) {
                if ('error' === textStatus) {
                    return $(this).html(responseText);
                }

                attachDataTables($modal);
            })
        ;
    }

    function showExperiment() {
        let baseUrl = $checkExperiment.data('base-ankieter-url');
        let queryData = {};
        queryData['random_param1'] = makeId(3);
        queryData['random_param2'] = makeId(3);
        queryData['random_param3'] = makeId(3);
        if ($genderToggle.is(':checked') && $genderVariableName.val().length && $genderFemaleValue.val().length && $genderMaleValue.val().length) {
            queryData[$genderVariableName.val()] = [$genderFemaleValue.val(), $genderMaleValue.val()][+((Math.random() > 0.5))]
        }

        if (!$captureAllVariablesToggle.is(':checked')) {
            $variablesToPass.val().forEach(val => queryData[val] = makeId(3));
        }

        let stringifiedParams = new URLSearchParams(queryData).toString();
        window.open(baseUrl + (baseUrl.includes('?') ? '&' : '?') + stringifiedParams);
    }

    // handlers
    $checkData.on('click', showAnkieterData);
    $checkExperiment.on('click', showExperiment);


    $('.show-variables-switch').on('click', function (e) {
        const isChecked = $(this).prop('checked');
        $(this).parents('.link-section').find('.redirects-link').find('input').prop("readonly", !isChecked);
        $(this).parents('.link-section').find('.redirects-tag').find('select').prop("disabled", !isChecked);
    });

    const $switchCaptureAllVariables = $('#capture_all_variables');
    const $switchQuotaFull = $('#full_quota\\.is_enabled');
    const $switchScreenOut = $('#screen_out\\.is_enabled');
    const $switchComplete = $('#complete\\.is_enabled');
    const $sreenOutDynamic = $('#screen_out\\.dynamic_variables');
    const $quotaFullDynamic = $('#full_quota\\.dynamic_variables');
    const $linkComplete = $('#complete\\.link');
    const $constantVariablesComplete = $('#complete\\.constant_variables');
    const $dynamicVariablesComplete = $('#complete\\.dynamic_variables');

    function determineStateCompleteLink() {
        $linkComplete.prop('readonly', !$switchComplete.is(':checked'));
    }

    function determineStateCompleteConstantVariables() {
        $constantVariablesComplete.prop('disabled', !$switchComplete.is(':checked'));
    }

    function determineStateDynamicVariables() {
        $dynamicVariablesComplete.prop('disabled',
            $switchCaptureAllVariables.is(':checked')
            || !$switchComplete.is(':checked')
        );
    }

    $switchComplete
        .on('change', determineStateCompleteLink)
        .on('change', determineStateCompleteConstantVariables)
        .on('change', determineStateDynamicVariables)
    ;

    $switchQuotaFull.on('change', function () {
        if ($switchCaptureAllVariables.prop('checked') || ($switchQuotaFull.prop('checked')) == false) {
            $quotaFullDynamic.prop("disabled", true);
        } else {
            $quotaFullDynamic.prop("disabled", false);
        }
    });

    $switchScreenOut.on('change', function () {
        if ($switchCaptureAllVariables.prop('checked') || ($switchScreenOut.prop('checked')) == false) {
            $sreenOutDynamic.prop("disabled", true);
        } else {
            $sreenOutDynamic.prop("disabled", false);
        }
    });

    $switchCaptureAllVariables
        .on('change', determineStateDynamicVariables)
        .on('click', function (e) {
        const isChecked = $(this).prop('checked');
        $('#variables_to_pass').prop("disabled", isChecked);
        if ((isChecked) || ($switchQuotaFull.prop('checked')) == false) {
            $quotaFullDynamic.prop("disabled", true);
        } else {
            $quotaFullDynamic.prop("disabled", false);
        }

        if ((isChecked) || ($switchScreenOut.prop('checked')) == false) {
            $sreenOutDynamic.prop("disabled", true);
        } else {
            $sreenOutDynamic.prop("disabled", false);
        }
    });


    $('#variables_to_pass').on('select2:custom:tag-created', function (event, newTag) {
        const $tag = $(`
            <option selected value="${newTag}">
                ${newTag}
            </option>
        `);

        const $completeDynamicSelect = $('#complete\\.dynamic_variables');
        $completeDynamicSelect.append($tag.clone());
        const $quotaFullDynamicSelect = $('#full_quota\\.dynamic_variables');
        $quotaFullDynamicSelect.append($tag.clone());
        const $screenOutDynamicSelect = $('#screen_out\\.dynamic_variables');
        $screenOutDynamicSelect.append($tag.clone());
    })

    $('#redirect-public-link, #survey-entry-link').click(function () {
        const $this = $(this);
        const element = $(this).get(0);
        // @see https://www.w3schools.com/howto/howto_js_copy_clipboard.asp
        element.select();
        element.setSelectionRange(0, 99999);
        document.execCommand('copy');
        $(this).tooltip({title: 'Copied!', trigger: 'manual'}).tooltip('show');
        setTimeout(function () {
            $this.tooltip('dispose');
        }, 1000);
    })

    $('#apply-check-experiment').on('click', function () {
        $('[name="check_experiment"]').val('on');
        $('form.redirects-form').submit();
    })

    $genderToggle.on('change', function () {
        $('.select_by_variables_data').slideToggle();
        $genderVariableName
            .add($genderFemaleValue)
            .add($genderMaleValue)
            .attr('readonly', !$(this).is(':checked'))
            .attr('required', $(this).is(':checked'));
    })
    attachAdvancedSettings();
}

execute_on('survey.redirects.edit', redirectsPageHandler);
execute_on('survey.public.redirects.edit', redirectsPageHandler);

